import { BlocksIconStarFilled } from 'blocks-nextjs/blocks-web-components/components/icon/icons/star-filled';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconStarFilled = createComponent({
  react: React,
  tagName: 'cat-icon-star-filled',
  elementClass: BlocksIconStarFilled
});
